import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect, useState, useCallback } from "react";
import { LanguageProvider } from "./context/LanguageContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import SplashScreen from "./components/SplashScreen";
import Home from "./pages/Home";
import Showcase from "./pages/Showcase";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import Services from "./pages/Services";
import About from "./pages/About";
import Contact from "./pages/Contact";
import WhatsAppButton from "./components/WhatsAppButton";
import useConsentBootstrap from "./hooks/useConsentBootstrap";
import usePageTracking from "./hooks/usePageTracking";
import "./styles/global.css";

function hasPrerenderedMarkup() {
  if (typeof document === "undefined") return false;
  const root = document.getElementById("root");
  return Boolean(root && root.hasChildNodes());
}

// Skip splash if the page loaded fast (< 600 ms) — avoids showing it on fast connections
function pageLoadedFast() {
  try { return typeof performance !== "undefined" && performance.now() < 600; }
  catch { return true; }
}

document.body.style.backgroundImage = "linear-gradient(rgba(0,0,0,0.72), rgba(0,0,0,0.72)), url('/images/hero/background.jpg')";
document.body.style.backgroundSize = "cover";
document.body.style.backgroundRepeat = "no-repeat";
document.body.style.backgroundAttachment = "fixed";
document.body.style.backgroundPosition = "center";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function AppInner() {
  usePageTracking();

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <div style={{
        position: "fixed", top: 0, left: 0, right: 0, height: "130px",
        background: "linear-gradient(to bottom, rgb(28,16,10) 0%, rgb(28,16,10) 45%, rgba(28,16,10,0.7) 70%, rgba(28,16,10,0.2) 88%, transparent 100%)",
        zIndex: 999, pointerEvents: "none",
      }} />
      <main style={{ position: "relative" }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/showcase" element={<Showcase />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/:id" element={<ProjectDetail />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
      <Footer />
      <WhatsAppButton />
    </>
  );
}

export default function App() {
  const [ready, setReady] = useState(() => hasPrerenderedMarkup() || pageLoadedFast());
  const handleDone = useCallback(() => setReady(true), []);

  useConsentBootstrap();

  return (
    <BrowserRouter>
      <LanguageProvider>
        {!ready && <SplashScreen onDone={handleDone} />}
        {ready && <AppInner />}
      </LanguageProvider>
    </BrowserRouter>
  );
}
